import { useContext } from 'react';
import { ColumnFilterRegistryContext } from '../../components/Manager/Grid/context/ColumnFilterRegistryContext/ColumnFilterRegistryContext';

export const useColumnFilterRegistryContext = () => {
  const context = useContext(ColumnFilterRegistryContext);

  if (context.isProvided === false) {
    throw new Error(
      'useColumnFilterRegistryContext must be used within a ColumnFilterRegistryContextProvider'
    );
  }

  return context;
};
